var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0687 3.7319L10.9052 0.567733C10.8 0.462511 10.6751 0.379044 10.5377 0.322097C10.4002 0.26515 10.2529 0.23584 10.1041 0.23584C9.95531 0.23584 9.80798 0.26515 9.67052 0.322097C9.53306 0.379044 9.40816 0.462511 9.30297 0.567733L0.572304 9.2991C0.466652 9.40392 0.382888 9.52868 0.325882 9.66616C0.268876 9.80363 0.239765 9.95106 0.24024 10.0999V13.264C0.24024 13.5645 0.359593 13.8526 0.572041 14.0651C0.78449 14.2775 1.07263 14.3969 1.37308 14.3969H4.53725C4.68607 14.3974 4.8335 14.3682 4.97097 14.3112C5.10844 14.2542 5.23321 14.1705 5.33802 14.0648L14.0687 5.33416C14.1739 5.22896 14.2574 5.10407 14.3143 4.96661C14.3713 4.82915 14.4006 4.68182 14.4006 4.53303C14.4006 4.38424 14.3713 4.23691 14.3143 4.09945C14.2574 3.96199 14.1739 3.8371 14.0687 3.7319ZM4.53725 13.264H1.37308V10.0999L7.60371 3.86926L10.7679 7.03342L4.53725 13.264ZM11.5686 6.23194L8.40448 3.06848L10.1037 1.36922L13.2679 4.53268L11.5686 6.23194Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e59269b70cdbbe254623d0b8a4364a94.svg";
export { ForwardRef as ReactComponent };